import React, { Component, useEffect, useState } from "react";
import { Redirect, Link } from "react-router-dom";
import { useHistory, useLocation } from "react-router-dom";
import Loader from "../../components/styled-components/loader/loader";
import PhoneNumber from "../../components/form/components/Countrycode";
import { Button } from "../../components/button/Button";
import { Input } from "../../components/input/Input";
import { InputGroup } from "../../components/inputGroup/InputGroup";
import Base64 from "../../utils/base64";
import { useDispatch, useSelector } from "react-redux";
import { postLoginUser, loginSelector } from "../../redux/slices/loginSlice";
import "./Login.css";
import Dashboard from "../Dashboard";
// import PhoneNumber from "./Countrycode";
import axios from "axios";
import ROUTES from "../../config/routes";
import swal from "sweetalert";
import moment from "moment";
import Tap from "@tapfiliate/tapfiliate-js";
import { ToolTipCreator } from "../../helpers/ToolTipCreator";

function Signup() {
  const userLoginToken = localStorage.getItem("userLoginToken");

  const [token, setToken] = useState(userLoginToken);
  const [loading, setLoading] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const location = useLocation();
  console.log("loaction in signup", location);
  const assetPlanetClientName = "asset_planet_resource";
  const assetPlanetClientPassword = "a_p_creds";
  const basicCreds = Base64.btoa(
    assetPlanetClientName + ":" + assetPlanetClientPassword
  );
  const handleOnChange = () => {
    setIsChecked(!isChecked);
  };
  const config = {
    headers: {
      "Content-type": "Application/json",
      Authorization: "Basic " + basicCreds,
    },
  };

  const user = useSelector((state) => state.rootReducer.loginUser);
  const dispatch = useDispatch();

  const [password, setPassword] = useState(false);
  const [username, setUserName] = useState(false);
  const [userData, setUserData] = useState({});

  const history = useHistory();

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSignup();
    }
  };
  const handleInputChange = (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    setUserData({ ...userData, [name]: value });
  };

  const handleSignup = async () => {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get("ref");
    console.log("code", code);
    const defaultSetting = {
      dragDrop: [
        {
          id: "budgetExpanse",
        },
        {
          id: "dashboardBudgetSection",
        },
        {
          id: "dashboardSavingSection",
        },
        {
          id: "topMonthlyExpanse",
        },
        {
          id: "goalProgress",
        },
        {
          id: "dashboardGoalCharts",
        },
        {
          id: "dashboardGoalSection",
        },
      ],
      dragCards: [
        {
          id: "budgetExpanse",
        },
        {
          id: "dashboardBudgetSection",
        },
        {
          id: "dashboardSavingSection",
        },
        {
          id: "topMonthlyExpanse",
        },
        {
          id: "goalProgress",
        },
        {
          id: "dashboardGoalCharts",
        },
        {
          id: "dashboardGoalSection",
        },
      ],
      dashboard1DragCards: [
        {
          id: "topMonthlyExpanse",
        },
        {
          id: "goalProgress",
        },
        {
          id: "dashboardGoalCharts",
        },
      ],
      dashboard2DragCards: [
        {
          id: "DashboardCalendar",
        },
      ],
      dashboard3DragCards: [
        {
          id: "topMonthlyExpanse",
        },
        {
          id: "goalProgress",
        },
        {
          id: "dashboardGoalCharts",
        },
      ],
    };
    if (userData.password !== userData.repassword) {
      swal("Oops!", "Passwords do not match", "error");
    } else if (
      userData &&
      userData.name &&
      userData.username &&
      userData.password &&
      userData.email &&
      userData.phone
    ) {
      const payload = {
        name: userData.name,
        userName: userData.username,
        password: userData.password,
        email: userData.email,
        phoneNumber: userData.phone,
        zipCode: +userData.zipCode,
        roles: [22],
        alpha2Code: "US",
        appJoiningDate: moment().format("MMDDYY"),
        source: "Web",
        tapfiliateRefCode: code && code,
        tapfiliateLink: code && `${window.location}`,
        setting: defaultSetting,
      };
      try {
        setLoading(true);
        const res = await axios.post(
          `${ROUTES.BASE_URL}/auth-service/auth/signup`,
          payload,
          config
        );
        setLoading(false);
        console.log("response signup verify", res);
        if (res.status === 200) {
          await handleAutoLogin();
          swal("Success!", res.data.message, "success");
          if (code) {
            Tap.customer(userData.name);
          }
          // Tap.conversion(userData.name, 30.0);
        }
      } catch (error) {
        setLoading(false);
        if(error && error.response && error.response.data && error.response.data.message){
          console.log("eroor", error.response.data.message);
          swal("Oops!", error.response.data.message, "error");
        }
      }
      console.log("userData", userData);
    } else {
      swal(
        "Oops!",
        (userData && !userData.name && "Please enter a valid Name") ||
          (userData && !userData.username && "Please enter a valid Username") ||
          (userData && !userData.email && "Please enter valid email address") ||
          (userData && !userData.phone && "Please enter valid Phonenumber") ||
          (userData && !userData.password && "Please enter valid Password"),
        "error"
      );
    }
  };

  const handleAutoLogin = async () => {
    try {
      setLoading(true);
      const res = await axios.post(
        `${ROUTES.BASE_URL}/auth-service/auth/signin`,
        {
          username: userData.username,
          password: userData.password,
        },
        config
      );
      console.log("responsse of login", res.data);
      setLoading(false);
      let outputObj = {};
      if (res.status === 200 && res.data.access_token) {
        console.log("resonse.data login", res.data);

        if (res.data.user.roles) {
          const loginRole = res.data.user.roles;
          console.log("loginRole", loginRole);
          if (loginRole) {
            let recursive = (obj, name) => {
              for (let key in obj) {
                if (typeof obj[key] == "object") {
                  recursive(obj[key], name + "_" + key);
                } else {
                  outputObj[key] = obj[key];
                }
              }
            };
            recursive(loginRole, "loginRole");
            console.log("outputObj", outputObj);
            localStorage.setItem("role", JSON.stringify(outputObj.name));
          }
        }
        localStorage.setItem("userData", JSON.stringify(res.data.user));
        localStorage.setItem("User", res.data.user.name);
        localStorage.setItem("userName", res.data.user.userName);
        if (res.data.user.image !== null) {
          localStorage.setItem("profile", res.data.user.image);
        }
        localStorage.setItem("userLoginToken", res.data.access_token);

        if (res.data.user.permissions) {
          let permissions = res.data.user.permissions;
          const namesArray = Object.values(permissions).map(
            (permission) => permission.name
          );
          console.log("namesArray", namesArray);
          localStorage.setItem("permissionState", JSON.stringify(namesArray));
        }

        if (res.data.access_token) {
          if (
            location.state &&
            location.state.from &&
            location.state.from.pathname
          ) {
            history.push({
              pathname: location.state.from.pathname,
              state: { from: location.state.from },
              PathExact: location.PathExact,
            });
            console.log("here in api");
          } else {
            if (outputObj.name === "inactiveClient") {
              history.push("/payment");
            } else {
              history.push("/free-trial");
            }
          }
        }
      }
    } catch (error) {
      setLoading(false);
      if(error && error.response && error.response.data && error.response.data.message){
        swal("Oops!", error.response.data.message, "error");
      }
      console.log(error);
    }
  };

  return (
    <div style={{ marginTop: "20px" }}>
      <div className="login-card border">
        <h2 className="login-heading">Sign Up</h2>
        <div>
          <InputGroup>
            <label>
              Name<span style={{ color: "red" }}>*</span>
            </label>
            <Input
              onChange={handleInputChange}
              id="name"
              type="text"
              placeholder="Name"
              name="name"
              required
            ></Input>
          </InputGroup>
          <InputGroup>
            <label>
              Username<span style={{ color: "red" }}>*</span>
            </label>
            <Input
              onChange={handleInputChange}
              id="username"
              type="text"
              placeholder="Username"
              name="username"
            ></Input>
          </InputGroup>

          <InputGroup>
            <label>
              Email Address<span style={{ color: "red" }}>*</span>
            </label>
            <Input
              onChange={handleInputChange}
              id="email"
              type="email"
              placeholder="Email Address"
              name="email"
            ></Input>
          </InputGroup>

          <InputGroup>
            <label>Zip Code</label>
            <Input
              onChange={handleInputChange}
              id="zipCode"
              type="text"
              placeholder="Zip Code"
              name="zipCode"
            ></Input>
          </InputGroup>

          <InputGroup>
            <label>
              Mobile Phone Number<span style={{ color: "red" }}>*</span>
            </label>
            <PhoneNumber
              id="phone"
              name="phone"
              onKeyPress={handleKeyPress}
              onChange={(e) => {
                setUserData({ ...userData, phone: e.target.value });

                // setUserData({ phone: e.target.value });
              }}
              size="large"
              placeholder="Phone Number"
            ></PhoneNumber>
          </InputGroup>

          {/*<InputGroup>
            <label>Invitation Code</label>
            <Input
              onChange={handleInputChange}
              id="invitation"
              type="text"
              placeholder="Invitation Code if Applicable"
              name="invitation"
            ></Input>
            </InputGroup> */}

          <InputGroup>
            <label>
              Password<span style={{ color: "red" }}>*</span>
            </label>
            <Input
              onChange={handleInputChange}
              onKeyPress={handleKeyPress}
              id="password"
              type="password"
              placeholder="Password"
              name="password"
            ></Input>
          </InputGroup>

          <InputGroup>
            <label>
              Re-enter Password<span style={{ color: "red" }}>*</span>
            </label>
            <Input
              onChange={handleInputChange}
              onKeyPress={handleKeyPress}
              id="re-password"
              type="password"
              placeholder="Re-enter Password"
              name="repassword"
            ></Input>
          </InputGroup>
          <div style={{ marginTop: "1rem", marginBottom: "1rem" }}>
            <label class="container1">
              <input
                type="checkbox"
                id="check"
                name="check"
                value="yes"
                checked={isChecked}
                onChange={handleOnChange}
              />
              <span class="checkmark"></span>
              <div style={{ fontSize: "16px" }}>
                I agree to{" "}
                <a
                  style={{ color: "#2A3DA3", textDecoration: "underline" }}
                  href="https://assetplanet.com/privacy-policy/"
                  target="_blank"
                >
                  Terms & Conditions
                </a>
              </div>
            </label>
          </div>
          {/* 
          {password && username ? (
            <div
              style={{ color: "red", textAlign: "left", paddingBottom: "20px" }}
            >
              Please enter Username and Password
            </div>
          ) : username ? (
            <div
              style={{ color: "red", textAlign: "left", paddingBottom: "20px" }}
            >
              Please enter Username{" "}
            </div>
          ) : password ? (
            <div
              style={{ color: "red", textAlign: "left", paddingBottom: "20px" }}
            >
              Please enter Password{" "}
            </div>
          ) : user.loading ? (
            <div style={{ paddingBottom: "20px", paddingBottom: "20px" }}>
              Loading.....
            </div>
          ) : (
            <div style={{ color: "red", paddingBottom: "20px" }}>
              {user.error}
            </div>
          )}
*/}
          <Button
            style={{
              background: "#2A3DA3",
              opacity: isChecked ? "1" : "0.5",
              cursor: isChecked ? "pointer" : "not-allowed",
            }}
            onClick={() => {
              handleSignup();
            }}
            disabled={!isChecked}
          >
            Sign up
          </Button>
          <div
            style={{
              marginTop: "1rem",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <InputGroup>
              <label>
                Are You Client?{" "}
                <dvi style={{ color: "rgb(57, 181, 74" }}>
                  <a style={{ color: "#2A3DA3" }} href="/login">
                    Login here
                  </a>
                </dvi>
              </label>
              <label>
                Are You Trusted Individual?{" "}<ToolTipCreator name="Are_You_Trusted_Individual" />
                <dvi style={{ color: "rgb(57, 181, 74" }}>
                  <a style={{ color: "#2A3DA3" }} href="/trusteeLogin">
                    Login here
                  </a>
                </dvi>
              </label>
            </InputGroup>
          </div>
        </div>
      </div>
      <Loader isLoading={loading}></Loader>
    </div>
  );
}

export default Signup;
